module.exports = __webpack_public_path__ + "static/media/dirad_logo.d25efccc.png";